import {Component} from "@angular/core";

@Component({
  selector: 'app-emailotp',
  templateUrl: './emailotp.component.html'
})
export class EmailotpComponent {}
